import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Chip, Avatar } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';

const ClientsTableRow = ({
    client,
    index,
    perms,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    page,
    perPage,
    isArabic,
}) => {
    const isSelected = selectedIds.includes(client.id);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, client.id)}
                />
            </TableCell>

            {/* S/N */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {(page - 1) * perPage + index + 1}
            </TableCell>

            {/* الاسم */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ fontWeight: 500 }}>
                {isArabic 
                    ? (client?.name?.ar || client?.name?.en || (typeof client?.name === 'string' ? client.name : '-')) 
                    : (client?.name?.en || client?.name?.ar || (typeof client?.name === 'string' ? client.name : '-'))
                }
            </TableCell>

            {/* الشعار */}
            <TableCell align="center">
                {client?.logo ? (
                    <Avatar
                        src={client.logo}
                        alt="Logo"
                        sx={{ width: 40, height: 40 }}
                    />
                ) : (
                    <Chip label={isArabic ? "لا يوجد شعار" : "No Logo"} size="small" variant="outlined" />
                )}
            </TableCell>

            {/* تاريخ الإضافة */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ whiteSpace: 'nowrap' }}>
                {client?.created_at ? dayjs(client.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            {/* الإجراءات */}
            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, client)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default ClientsTableRow;